const areaLabels = [
  {
    label: 'A',
    lat: 49.917971,
    lng: -97.210806,
  },
  {
    label: 'B',
    lat: 49.91845,
    lng: -97.210806,
  },
  {
    label: 'C',
    lat: 49.918211,
    lng: -97.21201,
  },
  {
    label: 'D',
    lat: 49.9178734,
    lng: -97.21283155,
  },
  {
    label: 'E',
    lat: 49.918298,
    lng: -97.2134309,
  },
  {
    label: 'F',
    lat: 49.91871675,
    lng: -97.21283155,
  },
  {
    label: 'H',
    lat: 49.91928,
    lng: -97.21133,
  },
  {
    label: 'J',
    lat: 49.919966,
    lng: -97.21032,
  },
  {
    label: 'M',
    lat: 49.919966,
    lng: -97.2093,
  },
  {
    label: 'P',
    info: 'Centre for Applied Research in Sustainable Infrastructure',
    lat: 49.91822,
    lng: -97.20984,
  },
  {
    label: 'T',
    info: 'Skilled Trades and Technology Centre',
    lat: 49.918,
    lng: -97.2084,
  },
  {
    label: 'V',
    lat: 49.91842,
    lng: -97.207251,
  },
  {
    label: 'Z',
    info: 'Jan den Oudsten Vehicle Technology & Research Centre',
    lat: 49.919966,
    lng: -97.20832,
  },
  {
    label: 'Greenhouse',
    lat: 49.92015175,
    lng: -97.2130267,
  },
  {
    label: 'South Gym',
    lat: 49.91757,
    lng: -97.21036,
  },
  {
    label: 'North Gym',
    lat: 49.91914,
    lng: -97.21201,
  },
  {
    label: 'A',
    lat: 49.900535,
    lng: -97.141708,
  },
  {
    label: 'W',
    lat: 49.900098,
    lng: -97.142028,
  },
  {
    label: 'P',
    lat: 49.900172,
    lng: -97.141447,
  },
];

export default areaLabels;
